export default __webpack_public_path__ + "static/media/AE_BRAND_LOGO.c69023ab.png";